var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"generic-info-card centering-container",class:{
    'image-on-the-right': !!_vm.imageOnTheRight,
    'dark-mode': !!_vm.darkMode,
  }},[_c('img',{attrs:{"src":_vm.imageSrc}}),_c('section',{staticClass:"content"},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"description"},[_vm._v(" "+_vm._s(_vm.description)+" ")]),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }